const initialState = {
    currentPage: '/',
};

export const MUTATE_STATE = "MUTATE_STATE_SIGN_UP";

const signUp = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.payload
            };
        default:
            return state;
    }
};

export default signUp;
